import get from 'lodash/get';

const fullName = (profile) => {
  if (profile) {
    return `${get(profile, 'first_name') || ''} ${get(profile, 'last_name') || ''}`.trim();
  }
  return null;
};

export {
  fullName,
};

export default {
  fullName,
};
